// =============================================================================
// LoadingScreen.tsx — Initial loading / splash screen
// Project: Texas Hold'em Social Casino
// =============================================================================
// Shown while the platform SDK initializes and the player logs in.

import React from 'react'

export default function LoadingScreen(): React.ReactElement {
  return (
    <div className="flex-center" style={{ flex: 1, flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 48 }}>♠</div>
      <div style={{ color: '#f5c518', fontSize: 20, fontWeight: 800, letterSpacing: 1 }}>
        POKER CLUB
      </div>
      <div style={{ color: '#888', fontSize: 13 }}>
        Loading...
      </div>
    </div>
  )
}
